var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResources(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7189 8.52728L17.8442 9.67696L18.2891 9.92693C19.237 10.4595 19.237 11.8325 18.2891 12.365L12.2525 15.7566C10.8524 16.5432 9.14756 16.5432 7.74754 15.7566L1.71092 12.365C0.763024 11.8325 0.763026 10.4595 1.71093 9.92693L2.15585 9.67696L4.16334 8.52728M16.1811 13.6461L18.1129 14.6185C19.1092 15.1201 19.1412 16.5398 18.1685 17.0862L12.2525 20.4101C10.8524 21.1966 9.14756 21.1966 7.74754 20.4101L1.9178 17.1347C0.928395 16.5789 0.982913 15.1278 2.0112 14.6487L4.16334 13.6461M12.2525 10.8112L18.2891 7.41961C19.237 6.88705 19.237 5.51405 18.2891 4.98149L12.2525 1.58993C10.8524 0.803358 9.14756 0.803356 7.74754 1.58993L1.71093 4.98149C0.763027 5.51405 0.763024 6.88705 1.71092 7.41961L7.74754 10.8112C9.14756 11.5977 10.8524 11.5977 12.2525 10.8112Z",
    stroke: "currentcolor",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResources);
export default __webpack_public_path__ + "static/media/resources.43726e38dc84e2ed64926c67d45bc5fc.svg";
export { ForwardRef as ReactComponent };